import { INoRowsOverlayParams } from '@ag-grid-community/core';
import { INoRowsOverlayAngularComp } from '@ag-grid-community/angular';

import { Component } from '@angular/core';

@Component({
  selector: 'ft-no-row-overlay-render-my-literature',
  templateUrl: './no-row-overlay-render.component.html',
})
export class NoRowOverlayRenderMyLiteratureComponent
  implements INoRowsOverlayAngularComp {
  agInit(params: INoRowsOverlayParams): void {}
}
